import { render, staticRenderFns } from "./OrderPendingPayment-Footer.vue?vue&type=template&id=5ec2accc&"
import script from "./OrderPendingPayment-Footer.vue?vue&type=script&lang=js&"
export * from "./OrderPendingPayment-Footer.vue?vue&type=script&lang=js&"
import style0 from "./OrderPendingPayment-Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports